/**
 * meta_pixel_controller.js — sends the Meta Pixel PageView for each page (Stimulus).
 *
 * Mounted by templates/components/ad_conversions.html only where Meta may run
 * (application/services/ad_conversions.py meta_pixel_id). Turbo replaces
 * <body> on every visit, so connect() runs once per page shown, which is the
 * PageView Meta builds retargeting audiences from.
 *
 * Performance: fbevents.js is loaded and the event sent only after the window
 * load event and an idle callback, so the Pixel never competes with first
 * paint. A Turbo preview (the cached snapshot shown before the real response)
 * is skipped, or one visit would count twice.
 */
import { Controller } from "@hotwired/stimulus";
import { metaPixel } from "./_meta_pixel.js";

function whenIdleAfterLoad(callback) {
    const idle = () => window.requestIdleCallback
        ? window.requestIdleCallback(callback, { timeout: 3000 })
        : setTimeout(callback, 1);
    if (document.readyState === "complete") idle();
    else window.addEventListener("load", idle, { once: true });
}

export default class extends Controller {
    static values = { id: String };

    connect() {
        if (document.documentElement.hasAttribute("data-turbo-preview")) return;
        whenIdleAfterLoad(() => {
            // The visitor may have navigated on before the browser went idle;
            // the next page's controller sends that page's own PageView.
            if (this.element.isConnected) metaPixel(this.idValue)("track", "PageView");
        });
    }
}
